import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, FileText } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/context/AuthContext";
import { QUOTE_STATUS } from "@/lib/utils-tr";

export default function AccountPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/quotes/mine").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-head text-2xl font-bold text-slate-900">Hesabım</h1>
          <p className="text-slate-500 text-sm mt-1">{user?.name} · {user?.email}</p>
        </div>
        <Button variant="outline" onClick={() => { logout(); navigate("/"); }} data-testid="logout-btn">
          <LogOut className="w-4 h-4 mr-1.5" /> Çıkış
        </Button>
      </div>

      <h2 className="font-head font-semibold text-slate-900 mb-4">Taleplerim ve Tekliflerim</h2>
      {items.length === 0 ? (
        <div className="text-center py-16 bg-white border rounded-xl text-slate-400" data-testid="no-quotes">
          <FileText className="w-10 h-10 mx-auto mb-3 text-slate-300" />
          Henüz bir teklif talebiniz yok.
          <div className="mt-4"><Link to="/urunler"><Button className="bg-teal-600 hover:bg-teal-700">Kataloğa Git</Button></Link></div>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((q) => (
            <Link key={q.quote_no} to={`/teklif/${q.quote_no}`} data-testid={`quote-${q.quote_no}`}
              className="block bg-white border border-slate-200 rounded-xl p-4 hover:border-teal-400 transition-colors">
              <div className="flex items-center justify-between flex-wrap gap-2">
                <div>
                  <div className="font-mono font-semibold text-slate-900">{q.quote_no}</div>
                  <div className="text-xs text-slate-500 mt-0.5">
                    {q.original_items?.length || 0} kalem · {(q.created_at || "").slice(0, 10)}
                  </div>
                </div>
                <Badge variant="outline" className={QUOTE_STATUS[q.status]?.cls}>
                  {QUOTE_STATUS[q.status]?.label || q.status}
                </Badge>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
